import { render, staticRenderFns } from "./InstanceCardImgNotAvailable.vue?vue&type=template&id=92d34a5a&scoped=true"
import script from "./InstanceCardImgNotAvailable.vue?vue&type=script&lang=js"
export * from "./InstanceCardImgNotAvailable.vue?vue&type=script&lang=js"
import style0 from "./InstanceCardImgNotAvailable.vue?vue&type=style&index=0&id=92d34a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d34a5a",
  null
  
)

export default component.exports